import PropTypes from 'prop-types'
import React from 'react'
import { Conditional } from '@resurs/react-utils'
import PhysicalIdentification from './PhysicalIdentification'

export const NaturalCustomerPhysicalIdentification = ({
  onChangeIdentification,
  onChangeCoApplicantIdentification,
  coApplicant = false,
  children: button,
  heading,
  idInfo: { customer = {}, coCustomer = {} },
  disabled,
}) => (
  <>
    <Conditional when={!!heading}>
      <h6 style={{ margin: 0, color: '#050505' }}>{heading}</h6>
    </Conditional>
    <Conditional when={!coApplicant}>
      <PhysicalIdentification
        name="applicant"
        onChange={onChangeIdentification}
        type={customer.type}
        reference={customer.reference}
        disabled={disabled}
      >
        {button}
      </PhysicalIdentification>
    </Conditional>
    <Conditional when={coApplicant}>
      {() => (
        <>
          <PhysicalIdentification
            name="applicant"
            onChange={onChangeIdentification}
            type={customer.type}
            reference={customer.reference}
            disabled={disabled}
          />
          <br />
          <PhysicalIdentification
            coApplicant
            name="co_applicant"
            onChange={onChangeCoApplicantIdentification}
            type={coCustomer.type}
            reference={coCustomer.reference}
            disabled={disabled}
          >
            {button}
          </PhysicalIdentification>
        </>
      )}
    </Conditional>
  </>
)

NaturalCustomerPhysicalIdentification.propTypes = {
  onChangeIdentification: PropTypes.func.isRequired,
  onChangeCoApplicantIdentification: PropTypes.func.isRequired,
  coApplicant: PropTypes.bool,
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  idInfo: PropTypes.object,
  disabled: PropTypes.bool,
}

NaturalCustomerPhysicalIdentification.defaultProps = {
  coApplicant: false,
  heading: '',
  idInfo: {},
  disabled: false,
}
